import { p as palette } from '../base/color-ec580bc4.js';
import { t as typography } from '../base/typography-dd13a6be.js';

const labelStyles = {
  color: typography.color.primary,
  colorDisabled: palette.gray[700],
  weight: '700',
  paddingBottom: '2px'
};
var labelStyles$1 = labelStyles;

export { labelStyles$1 as l };
//# sourceMappingURL=label-105be3d1.js.map
